export default __webpack_public_path__ + "static/media/No_tweets_available.816837ca.svg";